import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //baseurl: 'http://localhost:58112',
    sourceurl: 'http://toolhg.qiushifang.com/manage/1/',
    baseurl: 'http://hgapi.xuelintianxia.com',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
